/**
 * @return {{feature: string, click: string}}
 */
export const playlistCard = () => ({
  feature: 'playlist',
  click: 'playlist',
});
